export default "__VITE_ASSET__029ccf18__"